import { useState } from "react";
import { useTranslation } from "react-i18next";
import BillComponent from "src/components/user/bill-component";
import PaymentFormComponent from "src/components/user/payment-form-component";
import StepsForBillComponent from "src/components/user/steps-for-bill-component";

function PaymentContainer() {
  const { i18n, t } = useTranslation();
  const [nextButtonPressed, setNextButtonPressed] = useState<boolean>(false);

  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className="flex flex-col justify-center items-center h-full"
    >
      <StepsForBillComponent stepTwo={nextButtonPressed} />
      {nextButtonPressed ? <PaymentFormComponent /> : <BillComponent />}
      <div className="flex flex-row gap-4 justify-center items-center mobile:max-w-[569px] mobile:w-full">
        {!nextButtonPressed ? (
          <button
            onClick={() => {
              setNextButtonPressed(true);
            }}
            className="flex justify-center items-center h-11 w-[276.5px] mobile:w-full rounded-full bg-mint-500 border border-mint-500 font-arBold text-white text-xl"
          >
            {t("forms.component.next")}
          </button>
        ) : (
          <button className="flex justify-center items-center h-11 w-[276.5px] mobile:w-full rounded-full bg-mint-500 border border-mint-500 font-arBold text-white text-xl">
            {t("payment.container.pay")} 20,000{" "}
            {t("filterResult.component.riyal")}
          </button>
        )}
        {!nextButtonPressed ? (
          <button className="flex justify-center items-center h-11 w-[276.5px] mobile:w-full rounded-full bg-white border border-neutral-800 font-arBold text-neutral-800 text-xl">
            {t("payment.container.back")}
          </button>
        ) : (
          <button
            onClick={() => {
              setNextButtonPressed(false);
            }}
            className="flex justify-center items-center h-11 w-[276.5px] mobile:w-full rounded-full bg-white border border-neutral-800 font-arBold text-neutral-800 text-xl"
          >
            {t("payment.container.back")}
          </button>
        )}
      </div>
    </div>
  );
}

export default PaymentContainer;
